import type { PropsWithChildren } from 'react';
import { createContext } from 'react';

import { Spin } from 'antd';

import { useGetUserProfileDataQuery } from '@/api/endpoints/profile';
import type { IUserProfile } from '@/shared/types';

type UserDataProviderContextType = {
  userProfile: IUserProfile;
};

export const UserProfileProviderContext = createContext<UserDataProviderContextType>({} as UserDataProviderContextType);

export const UserProfileProvider = ({ children }: PropsWithChildren) => {
  const { data: userProfile, isError: hasUserError, isLoading: isUserLoading } = useGetUserProfileDataQuery();

  if (hasUserError) {
    return <p>Возникла ошибка при загрузке профиля</p>;
  }

  if (isUserLoading) {
    return (
      <Spin
        fullscreen
        size="large"
      />
    );
  }

  if (userProfile) {
    return (
      <UserProfileProviderContext.Provider value={{ userProfile }}>{children}</UserProfileProviderContext.Provider>
    );
  }

  return null;
};
